import { call, put, takeLatest } from "redux-saga/effects";
import {
  challanItemForDropdownSuccess,
  deleteChallanIdSuccess,
  challanList_ForListPageSuccess,
  GoButtonForChallanAddSuccess,
  makeChallanActionSuccess,
  saveChallan_ChallanAddSuccess,
  VDC_Item,
  VDC_Item_Success,
  VDC_Item_Details_Success,
  IB_Invoice_Error_Action,
  challanMasterBulkSuccess,
} from "./actions";
import {
  Challan_delete_API,
  Challan_get_API,
  Challan_items_API,
  Challan_items_Stock_API,
  Challan_Make_API,
  Challan_Save_API,
  ChallanMasterBulkApi,
  VDC_Item_API,
  VDC_Item_Details_API,
} from "../../../helpers/backend_helper";
import {
  CHALLAN_POST_API,
  DELETE_CHALLAN_FOR_CHALLAN_PAGE,
  CHALLAN_LIST_FOR_LIST_PAGE,
  GO_BUTTON_CHALLAN_POST_API,
  ITEM_DROPDOWN_CHALLAN,
  MAKE_CHALLAN_ACTION,
  VDC_ITEM,
  VDC_ITEM_DETAILS,
  CHALLAN_MASTER_BULK_ACTION,
} from "./actionType";
import { CommonConsole, date_dmy_func, convertTimefunc, listpageConcatDateAndTime, roundToDecimalPlaces, IsSweetAndSnacksCompany, isRACompany, loginSelectedPartyID, getOrderVisibilitySetting } from "../../../components/Common/CommonFunction";
import { makeGRN_Mode_1ActionSuccess } from "../GRNRedux/actions";
import { url } from "../../../routes";
import { GoButtonForinvoiceAddSuccess } from "../../actions";
import { invoice_discountCalculate_Func } from "../../../pages/Sale/Invoice/invoiceCaculations";


function* save_Challan_GerFunc({ data }) {                   // Save Challan  genrator function
  try {
    const response = yield call(Challan_Save_API, data);
    yield put(saveChallan_ChallanAddSuccess(response))
  } catch (error) { CommonConsole(error) }
}

function* Challan_List_filterGerFunc({ filters }) {          // Challan List Filter  genrator function
  const filter = JSON.parse(filters)

  try {
    const response = yield call(Challan_get_API, filters);
    const isSweetAndSnacksCompany = IsSweetAndSnacksCompany()
    const shouldHideDeleteBtn = getOrderVisibilitySetting().parentId === loginSelectedPartyID();
    const newList = yield response.Data.map((i) => {
      i["recordsAmountTotal"] = Number(i.GrandTotal || 0);
      const challanDate = date_dmy_func(i.ChallanDate);
      const createdDateTime = convertTimefunc(i.CreatedOn);
      i.ChallanDate = `${challanDate} ${createdDateTime}`;
      const DateAndTimeLable = `${challanDate} ${createdDateTime}`;
      i["transactionDate"] = i.CreatedOn; // transactionDate for sorting and filtering data 
      i["transactionDateLabel"] = DateAndTimeLable;

      i.ExtraSelect = false;
      i.selectCheck = false;
      i.forceSelectDissabled = false;
      i.forceExtraSelectDissabled = false;
      i.forceDeleteHide = false;
      if (i.ChallanTotalQty > 0) {
        i.Identify_id = 3;
      }
      if ((i?.inward)) {
        i.forceMakeBtnHide = true;
        i.Status = "Close"
      } else {
        i.forceMakeBtnHide = false;
        i.Status = "Open"
      }

      if (i.OrderComment?.trim() && (filter.ChallanMode === 1)) {
        i.Customer = `
        ${i.Customer}
        <br/>
        <span
            style="
                color:#856404;
                padding:2px 0px;
                border-radius:10px;
                font-size:15px;
                font-weight:600;
            "
        >
            Comment: ${i.OrderComment}
        </span>
    `;
      }

      if (isSweetAndSnacksCompany) {
        if (i.IsSendToFTPSAP) {
          i["isSend"] = false
          i.forceDeleteHide = true;
        } else {
          i["isSend"] = true
          i.forceDeleteHide = false;
        }
      }
      if (i.InvoiceCreated === true) {
        i.Status = "Invoice Created";
        i.forceExtraSelectDissabled = true;
        i.forceDeleteHide = true;
      }
      if (shouldHideDeleteBtn) {
        i.forceDeleteHide = true;
      }
      return i
    })
    yield put(challanList_ForListPageSuccess(newList))

  } catch (error) { CommonConsole(error) }
}

function* DeleteChallanGenFunc({ config }) {
  try {
    const response = yield call(Challan_delete_API, config);
    yield put(deleteChallanIdSuccess(response));
  } catch (error) {
    CommonConsole(error)
    yield put(IB_Invoice_Error_Action(error))   // add, plus a matching reset case in ChallanReducer
  }
};
function* Make_Challan_GerFunc({ config }) {                  // Make Chalan Challan  genrator function
  const { pageMode = '', path = '' } = config
  try {
    const response = yield call(Challan_Make_API, config);
    response["pageMode"] = pageMode;
    response["path"] = path; //Pagepath
    yield put(makeChallanActionSuccess(response))
  } catch (error) { CommonConsole(error) }
}

function* gobutton_challan_genFunc({ data }) {              //  GoButton Challan Addpage genrator function
  try {
    const arr = []
    const response = yield call(Challan_items_Stock_API, data);
    arr.push({ StockDetails: response.Data, })
    yield put(GoButtonForChallanAddSuccess(arr));
  } catch (error) { CommonConsole(error) }
}


function* VDC_Item_genFunc({ config }) {              //  GoButton Challan Addpage genrator function
  try {

    const response = yield call(VDC_Item_API, config);

    yield put(VDC_Item_Success(response.Data));
  } catch (error) { IB_Invoice_Error_Action(error) }
}

function* VDC_Item_Details_genFunc({ config }) {              //  GoButton Challan Addpage genrator function
  try {

    const response = yield call(VDC_Item_Details_API, config);

    yield put(makeGRN_Mode_1ActionSuccess(response));
  } catch (error) { yield put(IB_Invoice_Error_Action(error)) }
}




function* itemDropDown_Challan_AddPage_genFunc({ data }) {   //  Challan Addpage  IttemDropDown genrator function
  try {
    const response = yield call(Challan_items_API, data);
    yield put(challanItemForDropdownSuccess(response.Data));
  } catch (error) { CommonConsole(error) }
}

function* challanMasterBulkGenFunc({ config }) {

  try {
    const { jsonBody } = config;

    const response = yield call(ChallanMasterBulkApi, { jsonBody });

    if (response?.Status === true) {

      const bulkData = response.Data;

      const OrderItemDetails = bulkData.Items.map((item, index) => {

        const baseQty = Number(item.BaseUnitQuantity || item.Quantity || 0);
        const rate = Number(item.Rate || 0);

        const defaultUnit = isRACompany()
          ? item.UnitDetails?.find(u => Number(u.UnitID) === Number(item.Unit_id))
          : item.UnitDetails?.find(u => u.IsBase) || item.UnitDetails?.[0];

        const initialRate = rate;

        // 🔹 same formula used in invoice saga
        const _hasRate = (defaultUnit.BaseUnitQuantity / defaultUnit.BaseUnitQuantityNoUnit) * (isRACompany() ? defaultUnit.Rate : initialRate); // If RA company then use conversion rate as save in challan otherwise base rate.

        const _hasActualQuantity = (baseQty / defaultUnit.BaseUnitQuantity);

        const row = {
          Rate: roundToDecimalPlaces(_hasRate, 2),
          Qty: roundToDecimalPlaces(_hasActualQuantity, 3),
          GST: Number(item.CGSTPercentage) + Number(item.SGSTPercentage)
        };

        const calc = invoice_discountCalculate_Func(row, item, {});

        return {
          id: index + 1,

          Item: item.Item_id,
          ItemName: item.ItemName,

          initialRate: initialRate,

          Rate: row.Rate,
          Quantity: row.Qty,

          BaseUnitQuantity: baseQty,
          OrderQty: baseQty,

          Unit: item.Unit_id,
          UnitName: item.UnitName,

          SGST: Number(item.SGST),
          SGSTPercentage: Number(item.SGSTPercentage),

          GSTPercentage:
            Number(item.CGSTPercentage) + Number(item.SGSTPercentage),

          BatchDate: item.BatchDate,
          LiveBatch: item.LiveBatch_id,
          MRP_id: item.MRP_id,
          MRPValue: item.MRPValue,

          IGST: Number(item.IGSTPercentage).toFixed(2),
          IGSTPercentage: Number(item.IGSTPercentage).toFixed(2),

          GSTAmount: calc.roundedGstAmount,

          BatchCode: item.BatchCode,

          BasicAmount: calc.discountBaseAmt,

          CGST: Number(item.CGST),
          CGSTPercentage: Number(item.CGSTPercentage).toFixed(2),

          Discount: item.Discount,
          DiscountAmount: Number(item.DiscountAmount),
          DiscountType: item.DiscountType,

          TaxType: item.TaxType,
          GST: item.GST_id,

          BatchID: item.BatchID,

          default_UnitDropvalue: {
            value: defaultUnit?.UnitID || item.Unit_id,
            label: defaultUnit?.UnitName || item.UnitName,
            BaseUnitQuantity: defaultUnit?.BaseUnitQuantity || baseQty,
            BaseUnitQuantityNoUnit:
              defaultUnit?.BaseUnitQuantityNoUnit || 1
          },

          UnitDetails: (item.UnitDetails && item.UnitDetails.length > 0)
            ? item.UnitDetails.map(u => ({
              MUnitID: u.UnitID,
              UnitName: u.UnitName,
              BaseUnitQuantity: Number(u.BaseUnitQuantity),
              BaseUnitQuantityNoUnit: Number(u.BaseUnitQuantityNoUnit || 1),
              ConversionUnit: Number(u.BaseUnitQuantity),
              IsBase: u.IsBase,
              UnitID: u.UnitID
            }))
            : [{
              MUnitID: item.Unit_id,
              UnitName: item.UnitName,
              BaseUnitQuantity: baseQty,
              BaseUnitQuantityNoUnit: 1,
              ConversionUnit: 1,
              UnitID: item.UnitID
            }],

          Amount: calc.roundedTotalAmount,
          ItemTotalAmount: calc.roundedTotalAmount
        };
      });

      const updatedResp = {
        Status: true,
        StatusCode: 200,
        customer: {
          value: bulkData.CustomerID,
          label: bulkData.CustomerName,
          OrderIDs: bulkData.Challan_Ids.join(","),
          AdvanceAmount: 0,
          CustomerGSTIN: bulkData.CustomerGSTIN,
          IsTCSParty: bulkData.IsTCSParty,
          IsSEZ: bulkData.IsSEZ,
          CustomerSAPCode: bulkData.CustomerSAPCode,
        },
        Data: {
          OrderItemDetails,
          OrderIDs: bulkData.Challan_Ids.join(","),
          AdvanceAmount: 0,
          GrandTotal: Number(bulkData.GrandTotal).toFixed(2)
        }
      };

      yield put(GoButtonForinvoiceAddSuccess(updatedResp));
      yield put(challanMasterBulkSuccess(response));
    }
    else {
      yield put(challanMasterBulkSuccess(response));
    }

  } catch (error) {
    yield put(challanMasterBulkSuccess(error));
  }
}

function* ChallanSaga() {
  yield takeLatest(CHALLAN_POST_API, save_Challan_GerFunc);
  yield takeLatest(CHALLAN_LIST_FOR_LIST_PAGE, Challan_List_filterGerFunc);
  yield takeLatest(GO_BUTTON_CHALLAN_POST_API, gobutton_challan_genFunc);
  yield takeLatest(MAKE_CHALLAN_ACTION, Make_Challan_GerFunc);
  yield takeLatest(DELETE_CHALLAN_FOR_CHALLAN_PAGE, DeleteChallanGenFunc);
  yield takeLatest(ITEM_DROPDOWN_CHALLAN, itemDropDown_Challan_AddPage_genFunc);
  yield takeLatest(CHALLAN_MASTER_BULK_ACTION, challanMasterBulkGenFunc);

  yield takeLatest(VDC_ITEM_DETAILS, VDC_Item_Details_genFunc);

  yield takeLatest(VDC_ITEM, VDC_Item_genFunc);



}

export default ChallanSaga;
